import { Navigation } from './navigation';
import { MobileNavigation } from '../../components/mobile-nav';
import { getElement } from '../../lib/elementUtils';

window.addEventListener("load", () => {
    // Desktop navigation
    const navigation = new Navigation();

    // Mobile navigation
    const mobileNavRoot = document.querySelector<HTMLElement>(".mobile-menu");
    if (mobileNavRoot) {
        const mobileNavigation = new MobileNavigation(mobileNavRoot);
    }

    highlightCurrentMenuItem();
});

/**
 * @returns A query selector string which will resolve to the menu item that needs highlighting
 */
function getMenuItemSelectorToHighlight() {
    // Use current url to compare id of menu items
    const url = window.location.pathname.toLowerCase();
    const urlParams = new URLSearchParams(window.location.search);
    const urlToArray = url.split('/');
    let menuItemSelector = urlParams.toString() ? `[data-menu-item="${url}?${urlParams.toString().toLowerCase()}"]` : `[data-menu-item="${url}"]`;

    // Get menu item by id
    let menuItemToHighlight: HTMLElement | null = document.querySelector<HTMLElement>(menuItemSelector);
    if (menuItemToHighlight !== null) {
        return menuItemSelector;
    }

    // Try selecting a menu item without a query string
    menuItemSelector = `[data-menu-item="${url}"`;
    menuItemToHighlight = document.querySelector<HTMLElement>(menuItemSelector);
    if (menuItemToHighlight !== null) {
        return menuItemSelector;
    }

    // Check if user is under report or filedetails which are under manage
    if (urlToArray.includes('reports') || urlToArray.includes('filedetails')) {
        menuItemSelector = `/manage/${urlToArray[2]}`;
    }
    else if (urlToArray.includes('editschool')) {
        menuItemSelector = `/${urlToArray[1]}/manageschools`;
    }
    else if (urlToArray.includes('edituser')) {
        menuItemSelector = `/${urlToArray[1]}/manageusers`;
    }
    else if (urlToArray.includes('editnewsitem')) {
        menuItemSelector = `/${urlToArray[1]}/managenews`;
    }
    else if (url.includes('identity/account/register')) {
        menuItemSelector = `/administration/manageusers`;
    }
    // Url may have additional paths (LA users), check to see if the paths we're only concerned with can find the appropriate menu item
    else {
        if (urlToArray.length > 1) {
            menuItemSelector = `/${urlToArray[1]}/${urlToArray[2]}`;
        }
    }
    menuItemSelector = `[data-menu-item="${menuItemSelector}"]`;

    return menuItemSelector;
}

/**
 * Highlight the current menu item in the navigation
 */
function highlightCurrentMenuItem() {
    // Get the selector string matching items to highlight
    const menuItemSelector = getMenuItemSelectorToHighlight();

    // Get menu items matching the selector
    const menuItemsToHighlight = document.querySelectorAll<HTMLElement>(menuItemSelector);


    menuItemsToHighlight.forEach(menuItemToHighlight => {

        // Get parent menu items to highlight
        let menuItemParent = menuItemToHighlight?.parentElement?.parentElement;
        let menuItemGrandParent = menuItemParent?.parentElement?.parentElement;

        // Set highlight styling to menu items
        if (menuItemToHighlight) {
            menuItemToHighlight.classList.add('nav-menu__item--highlight');
            menuItemToHighlight.firstElementChild?.classList.add('nav-menu__item--text-color');
        }

        // Parent
        if (menuItemParent) {
            if (menuItemParent.tagName.toLowerCase() === "li") {
                // Desktop navigation
                menuItemParent.classList.add('nav-menu__item--highlight');
                menuItemParent.firstElementChild?.classList.add('nav-menu__item--text-color');
            } else {
                // Mobile navigation
                menuItemParent = menuItemToHighlight?.parentElement?.closest<HTMLElement>("details[role='menu']")?.querySelector("summary");
                menuItemParent?.classList.add('nav-menu__item--highlight', 'nav-menu__item--text-color');
            }
        }

        // Grandparent
        if (menuItemGrandParent) {
            if (menuItemGrandParent.tagName.toLowerCase() === "li") {
                // Desktop navigation
                menuItemGrandParent.classList.add('nav-menu__item--highlight');
                menuItemGrandParent.firstElementChild?.classList.add('nav-menu__item--text-color');
            } else {
                // Mobile navigation
                menuItemGrandParent = menuItemParent?.parentElement?.parentElement?.closest<HTMLElement>("details[role='menu']")?.querySelector("summary");
                menuItemGrandParent?.classList.add('nav-menu__item--highlight', 'nav-menu__item--text-color');
            }
        }

    });

}
